import { CREATE_SOLR_COLLECTION } from '../../constants/ActionTypes';
import { DELETE_SOLR_COLLECTION } from '../../constants/ActionTypes';
import { GET_SOLR_COLLECTIONS } from '../../constants/ActionTypes';

export function createSolrCollection(data) {
  const path = `/@create_solrcollection/`;

  return {
    type: CREATE_SOLR_COLLECTION,
    request: {
      op: 'post',
      path: path,
      data: data,
    },
  };
}

export function deleteSolrCollection(data) {
  const path = `/@delete_solrcollection/`;

  return {
    type: DELETE_SOLR_COLLECTION,
    request: {
      op: 'post',
      path: path,
      data: data,
    },
  };
}

export function getSolrCollections() {
  const path = `/@get_solrcollections/`;

  return {
    type: GET_SOLR_COLLECTIONS,
    request: {
      op: 'get',
      path: path,
    },
  };
}
